import {envVariables} from '../envVariables/envVariables'

const STORAGE_CONFIG_VERSION_KEY = 'pb_app_config_version'
const STORAGE_API_BASE_URL_KEY = 'pb_api_base_url'

const canUseBrowserStorage = () => typeof window !== 'undefined' && window.localStorage && window.sessionStorage

const getCurrentConfigVersion = () => envVariables.appConfigVersion || 'local'
const getCurrentBaseUrl = () => envVariables.baseUrl || ''

export const markCurrentAppConfig = () => {
	if (!canUseBrowserStorage()) return
	localStorage.setItem(STORAGE_CONFIG_VERSION_KEY, getCurrentConfigVersion())
	localStorage.setItem(STORAGE_API_BASE_URL_KEY, getCurrentBaseUrl())
}

const clearAsyncBrowserState = async () => {
	if (typeof window === 'undefined') return

	if ('caches' in window) {
		const cacheNames = await caches.keys()
		await Promise.all(cacheNames.map((name) => caches.delete(name)))
	}

	if ('serviceWorker' in navigator) {
		const registrations = await navigator.serviceWorker.getRegistrations()
		await Promise.all(registrations.map((registration) => registration.unregister()))
	}
}

export const clearAppStorage = async ({includeAsyncState = true} = {}) => {
	if (!canUseBrowserStorage()) return

	localStorage.clear()
	sessionStorage.clear()

	if (includeAsyncState) {
		try {
			await clearAsyncBrowserState()
		} catch (error) {
			console.warn('No fue posible limpiar cache o service workers.', error)
		}
	}
}

export const resetStorageIfConfigChanged = ({includeAsyncState = true} = {}) => {
	if (!canUseBrowserStorage()) return false

	const storedConfigVersion = localStorage.getItem(STORAGE_CONFIG_VERSION_KEY)
	const storedBaseUrl = localStorage.getItem(STORAGE_API_BASE_URL_KEY)
	const currentConfigVersion = getCurrentConfigVersion()
	const currentBaseUrl = getCurrentBaseUrl()
	const configChanged = storedConfigVersion !== currentConfigVersion || storedBaseUrl !== currentBaseUrl

	if (!configChanged) return false

	localStorage.clear()
	sessionStorage.clear()
	markCurrentAppConfig()

	if (includeAsyncState) {
		clearAsyncBrowserState().catch((error) => {
			console.warn('No fue posible limpiar cache o service workers.', error)
		})
	}

	return true
}

export const clearStorageForLoginIfRequested = async () => {
	if (!envVariables.clearStorageOnLogin) return false

	await clearAppStorage()
	markCurrentAppConfig()
	return true
}
